import {
  IItemSearchResponse,
  ItemFactory,
  IQueryData,
  ProductList,
  ProductListFilterItemRange,
  ProductListFilterItemRangeValue,
  ProductListFilterItemValueType,
} from "../../../../typescript-library";
import {getShopId} from "../../../lib/getShopId";

/**
 * Checks wether the min value set by the customer is below the range min value. This leverages the
 * default behaviour to unset a range filter, if a floor-rounded value is below the actual min value. <br>
 * This is necessary to show rebates "From XX percent". <br>
 * Returns the min value or false
 * @param instance
 * @param filters
 */
export const isPercentDiscountSetUnderMin = (
  instance: ProductList,
  filters: {[k: string]: ProductListFilterItemValueType},
): number | false => {
  const discountStateSetting = filters.percentageDiscount as ProductListFilterItemRangeValue | undefined;
  const discountInstanceSetting = instance.filter.filterItems.get("percentageDiscount") as
    | ProductListFilterItemRange
    | undefined;

  if (
    discountStateSetting &&
    discountInstanceSetting &&
    discountStateSetting.min <= discountInstanceSetting.value.min
  ) {
    return discountStateSetting.min;
  } else {
    return false;
  }
};

export const getRequestParams = (
  instance: ProductList,
  filters: {[k: string]: ProductListFilterItemValueType},
): IQueryData => {
  const paramData: IQueryData = {};

  const percentDiscountMinValue = isPercentDiscountSetUnderMin(instance, filters);
  if (percentDiscountMinValue) {
    paramData.percentageDiscount = `${percentDiscountMinValue}-`;
  }

  const marginWeight = new URLSearchParams(window.location.search).get("mw");
  if (marginWeight) {
    paramData.mw = getCorrectedMarginWeight(marginWeight);
  }

  const tempRequestParams: IQueryData = {...instance.requestParams};

  Object.keys(tempRequestParams).forEach((rqp) => {
    if (!tempRequestParams[rqp]) {
      delete tempRequestParams[rqp];
    }
  });

  Object.assign(tempRequestParams, paramData);

  return tempRequestParams;
};

/**
 * Pretty much a copy of the tslib `ProductList.send()` method, to apply some hijacked percentageDiscount
 * min values, that are below the very min value of the filter. See `getRequestParams()` and `isPercentDiscountSetUnderMin()`
 * @param requestParams
 */
export const getItemsWithPercentDiscount = async (
  requestParams: IQueryData,
): Promise<IItemSearchResponse> => {
  return await ItemFactory.getItems(getShopId(), requestParams);
};

// Werte 100 < x < 0 abfangen
export const getCorrectedMarginWeight = (marginWeight: string): string => {
  let mw = marginWeight;
  try {
    const num = Number(marginWeight);
    if (num < 0 || 100 < num) {
      mw = Math.max(0, Math.min(100, num)).toString();
    }
  } catch (e) {
    mw = "100";
  }

  return mw;
};
